import { Pipe, PipeTransform } from '@angular/core';

import { getGmaAlarmColor } from '../constants/constants';

@Pipe({ name: 'getGmaAlarmColor' })
export class GetGmaAlarmColorPipe implements PipeTransform {
  transform(stationDataByAlarmParameter: any) {
    return getGmaAlarmColor(stationDataByAlarmParameter);
  }
}
